<template>
  <div
    class="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mx-auto"
  >
    <div v-for="article in articles" :key="article.id" class="mx-auto">
      <div class="flex flex-col h-full">
        <ArticleCard
          :article-id="article.id"
          :title="article.title"
          :image-url="article.previewImage || article.thumbnailURL"
          :image-alt-text="article.previewImageAltText"
          :source-type="article.sourceType"
          :teaser="article.shortDescription"
          :is-favorite="article.isFavorite"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ArticleCard from "./ArticleCard.vue";
import "vue3-carousel/carousel.css";
import FeedContentDTO from "../../../dto/feed-content.dto.ts";
import { useClientStore } from "../../../store/v2/client";

const clientStore = useClientStore();

defineProps({
  articles: {
    type: Array as PropType<FeedContentDTO[]>,
    required: false,
  },
});
</script>
